// React
import React, { } from 'react';
// Components
import { Container } from 'react-bootstrap';
// Css
import "./footer.css"

export const Footer = () => {
    return (
        <div className='footer'>
            <Container>
                <div className='copyright'>©2024 Timescope. All rights reserved.</div>
            </Container>
        </div>
    );
}